<template>
  <div class="pa-5 director-detail-container">
    <v-divider class="primary mb-5"></v-divider>
    <v-layout row wrap>
      <div class="profile-section">
        <div class="profile-image" v-if="filmMaker.profile_picture">
            <img :src="filmMaker.profile_url" alt="Director Image">
        </div>
        <div class="profile-intro">
            <h1 :style="`color: ${colors.primaryColor}`">{{ filmMaker.name[currentLocale] }}</h1>
            <p  :style="`color: ${colors.secondaryColor}`">{{ filmMaker.short_description[currentLocale] }}</p>
        </div>
      </div>

      <div class="bio-section">
        <h2 :style="`color: ${colors.primaryColor}`">{{ $t("film.maker.profile.page.section.filmography.title") }}</h2>
        <p  :style="`color: ${colors.secondaryColor}`" v-html="filmMaker.filmography[currentLocale]"></p>
      </div>
    </v-layout>

    <v-divider class="primary mt-5"></v-divider>
    
    <ProgramSection v-if="currentCompany && currentCompany.active_program_count" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ProgramSection from '@/components/company/program/ProgramSection.vue';
export default {
  name: "FilmMakerProfile",
  components: {
    ProgramSection
  },
  data() {
    return {
      filmMaker: null,
    };
  },
  created() {
    this.get();
  },
  watch: {
    '$i18n.locale': function(newLocale, oldLocale) {
      this.get();
    }
  },
  computed: {
    ...mapState({
      currentCompany: state => state.company.company,
      colors: (state) => state.app.app.colors,
    }),
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    async get() {
      await this.$store
        .dispatch("filmMaker/get", {
          id: this.$route.params.filmMakerId,
        })
        .then((res) => {
          this.filmMaker = res;
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style scoped>

.profile-section {
    display: flex;
    gap: 30px;
    margin-bottom: 40px;
    align-items: flex-start;
}

.profile-image {
    width: 400px;
    min-width: 400px;
    padding: 10px;
}

.profile-image img {
    width: 100%;
    height: auto;
}

.profile-intro {
    flex: 1;
}

h1 {
    font-size: 2.5em;
    margin-bottom: 20px;
}

.bio-section h2 {
    font-size: 1.8em;
    margin: 30px 0 20px 0;
}

.bio-section p {
  margin-bottom: 15px;
}

@media (max-width: 768px) {
    .profile-section {
        flex-direction: column;
        align-items: center;
    }

    .profile-image {
        width: 300px;
        min-width: 300px;
        margin-bottom: 20px;
    }

    h1 {
        text-align: center;
    }
}

@media (max-width: 480px) {
    body {
        padding: 10px;
    }

    .profile-image {
        width: 150px;
        min-width: 150px;
    }

    .profile-section h1 {
        font-size: 2em;
    }

    .bio-section h2 {
        font-size: 1.5em;
    }
}
</style>
